import { api } from '../services/api'

export function useAppLaunch() {
  const launchApp = async (appId: string) => {
    try {
      const { url } = await api.get<{ url: string }>(`/apps/${appId}/launch`)
      window.open(url, '_blank')
    } catch (err) {
      console.error('Failed to launch app:', err)
      throw err
    }
  }

  return { launchApp }
}
